import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

export type ToastSeverity = 'info' | 'success' | 'warning' | 'error';

const SEVERITY_TO_PANEL_CLASS: Record<ToastSeverity, string> = {
  info: 'app-toast-info',
  success: 'app-toast-success',
  warning: 'app-toast-warning',
  error: 'app-toast-error',
};

const DEFAULT_DURATION_MS: Record<ToastSeverity, number> = {
  info: 4000,
  success: 3000,
  warning: 5000,
  error: 6000,
};

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly snackBar = inject(MatSnackBar);

  show(message: string, severity: ToastSeverity = 'info'): void {
    if (!message) return;
    this.snackBar.open(message, undefined, {
      duration: DEFAULT_DURATION_MS[severity],
      panelClass: [SEVERITY_TO_PANEL_CLASS[severity]],
      horizontalPosition: 'end',
      verticalPosition: 'top',
    });
  }
}
